export default __webpack_public_path__ + "static/media/ER.04bcc2d3.svg";